import { render, staticRenderFns } from "./CreateDocumentBulk.vue?vue&type=template&id=31304c3e&"
import script from "./CreateDocumentBulk.vue?vue&type=script&lang=js&"
export * from "./CreateDocumentBulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports